<template>

  <transition name="slide">
    <!-- <m-header></m-header> -->
      <!-- <div class="m-header">YES</div> -->
    <div class="user-center">
      <m-header></m-header>
      <div class="back" @click="back">
        <i class="icon-back"></i>
      </div>
      <div>{{$route.params.id}}</div>
      <div class="switches-wrapper">
        <switches @switch="switchItem" :switches="switches" :currentIndex="currentIndex"></switches>
      </div>
      <!-- <div ref="playBtn" class="play-btn" >
        <i class="icon-play"></i>
        <span class="text">隨機播放全部</span>
      </div> -->
      <div class="list-wrapper" ref="listWrapper">
        <scroll ref="favoriteList" class="list-scroll" v-if="currentIndex===0" :data="favoriteList">
          <div class="list-inner">
            <song-list :songs="favoriteList" @select="selectSong"></song-list>
          </div>
        </scroll>
      </div>
      
    </div>
  </transition>
</template>

<script>
import MHeader from 'components/m-header/m-header'
import Switches from 'base/switches/switches'
import Scroll from 'base/scroll/scroll'
import SongList from 'base/song-list/song-list'
import Song from 'common/js/song'
import { mapGetters, mapActions } from 'vuex'
import { playlistMixin } from 'common/js/mixin'

export default {
  mixins: [playlistMixin],
  data() {
    return {
      currentIndex: 0,
      // switches: [{ name: '我喜歡的' }, { name: '最近聽的' }]
      switches: [{ name: '我喜歡的' }]
    }
  },
  computed: {
    ...mapGetters(['favoriteList'])
  },
  methods: {
    handlePlaylist(playlist) {
      console.log('handlePlaylist')
      const bottom = playlist.length > 0 ? '60px' : ''
      this.$refs.listWrapper.style.bottom = bottom
      this.$refs.favoriteList && this.$refs.favoriteList.refresh()
      this.$refs.playList && this.$refs.playList.refresh()
    },
    switchItem(index) {
      this.currentIndex = index
    },
    selectSong(song) {
      console.log('selectSong')
      this.insertSong(new Song(song))
    },
    back() {
      this.$router.back()
    },
    ...mapActions(['insertSong'])
  },
  components: {
    Switches,
    Scroll,
    SongList,
    MHeader
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable';

.user-center {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  background: $color-background;

  &.slide-enter-active, &.slide-leave-active {
    transition: all 0.3s;
  }

  &.slide-enter, &.slide-leave-to {
    transform: translate3d(100%, 0, 0);
  }

  .back {
    position: absolute;
    top: 10px;
    left: 6px;
    z-index: 50;

    .icon-back {
      display: block;
      padding: 10px;
      font-size: $font-size-medium-x;
      color: $color-theme;
    }
  }

  .switches-wrapper {
    margin: 10px 0 30px 0;
  }

  .play-btn {
    box-sizing: border-box;
    width: 135px;
    padding: 7px 0;
    margin: 0 auto;
    text-align: center;
    border: 1px solid $color-text-l;
    color: $color-text-l;
    border-radius: 100px;
    font-size: 0;

    .icon-play {
      display: inline-block;
      vertical-align: middle;
      margin-right: 6px;
      font-size: $font-size-medium-x;
    }

    .text {
      display: inline-block;
      vertical-align: middle;
      font-size: $font-size-small;
    }
  }

  .list-wrapper {
    position: absolute;
    top: 100px;
    bottom: 0;
    width: 100%;

    .list-scroll {
      height: 100%;
      overflow: hidden;

      .list-inner {
        padding: 0px 20px;
      }
    }
  }

  .no-result-wrapper {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// user-center.vue?6a84ce9f